// @flow

import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { isParticipantModerator } from '../../../base/participants';
import { connect } from '../../../base/redux';
import AbstractGrantModeratorDialog
    from '../AbstractGrantModeratorDialog';

/**
 * Dialog to confirm a grant moderator action.
 */
class GrantModeratorDialog extends AbstractGrantModeratorDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (
            <Dialog
                okKey = 'dialog.Yes'
                onSubmit = { this._onSubmit }
                titleKey = { this.props._isModerator ? 'dialog.revokeModerationTitle' : 'dialog.grantModeratorTitle' }
                width = 'small'>
                <div>
                    {this.props._isModerator ? this.props.t('dialog.revokeModeration') : this.props.t('dialog.grantModeratorDialog') }
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

const _mapStateToProps = (state, ownProps) => {
    const partId = ownProps?.participantID;
    const participants = state['features/base/participants'];
    const isParticipant = Array.isArray(participants) && participants.filter(e => e.id === partId);
    const isModerator = isParticipantModerator(isParticipant[0]);

    return {
        _isModerator: isModerator
    };

};

export default translate(connect(_mapStateToProps)(GrantModeratorDialog));
